import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[readFc]',
  exportAs: 'get',
})
export class FormControlReaderDirective {
  constructor(public readonly control: NgControl) {}

  equals(value: any) {
    return this.control.value === value;
  }
}
